<template>
    <div class="immediatelyPay">
    <div class="header">
      <div class="headerDiv">
        <div class="call_back" @click="reBack">
          <img src="../../assets/shared-hotel/call.png" />
        </div>
        <div class="title">立即核销</div>
      </div>
    </div>
    <div class="content">
      <div class="pay_shop_body">
        <div class="pay_shop_div">
          <div class="pay_shop">
            <van-row class="pay_shop_row">
              <van-col class="pay_shop_img" span="4">
                <img :src="this.$route.query.shoplogo" />
              </van-col>
              <van-col class="pay_shop_name" span="20">{{
                this.$route.query.shopname
              }}</van-col>
            </van-row>
            <p class="consumption">消费总金额</p>
            <div class="sum_of_consumption">
              <span>¥</span>
              <input
                placeholder="请询问服务员后输入"
                v-model="money"
                type="number"
                class="money_input"
                @input="handleInput"
              />
            </div>
          </div>
        </div>
        <div class="hint">
          <p>温馨提示：</p>
          <p>1.红包单次最高可使用订单金额的50%；</p>
          <p>2.单笔订单实际付款额度小于或等于10000元；</p>
          <p>
            3.如果您的订单使用红包抵扣，但未完成支付，抵扣红包会冻结24小时后自动退回，您也可以在待支付订单中手动取消，取消后自动退回。
          </p>
          <p>4.卡包支付和红包不能同时抵扣；</p>
          <p>5.选择卡包支付只能全额抵扣；</p>
          <p>6.充值后已获得同等积分，卡包核销不能获得积分；</p>
          <p>7.卡包充值后，不支持退款；</p>
          <p>
            8.请按规范使用，确保消费真实有效，如有虚假交易则按平台规则处理。
          </p>
        </div>
      </div>
    </div>
    <div class="total_body" v-if="isshowbottom">
      <van-row class="total_title_body">
        <van-col span="15" class="total_div">
          <span class="total_title">合计&nbsp;</span>
          <span class="total_symbol">¥ </span>
          <span class="total_money">
            <!-- <span v-if="money && radio.length > 0">{{
              (deduction ? parseFloat(deduction).toFixed(2) : 0 + ".00").split(
                "."
              )[0] + "."
            }}</span> -->
            <span v-if="!money">0</span>
            <span v-else-if="money">{{
              (money ? parseFloat(money).toFixed(2) : 0 + ".00").split(".")[0]
            }}</span>
          </span>

          <span class="total_money_decimals">
            <!-- <span v-if="money && radio.length > 0">{{
              (deduction ? parseFloat(deduction).toFixed(2) : 0 + ".00").split(
                "."
              )[1]
            }}</span> -->
            <span v-if="!money">.00</span>
            <span v-else-if="money">
              {{
                "." +
                (money ? parseFloat(money).toFixed(2) : 0 + ".00").split(".")[1]
              }}
            </span>
          </span>
        </van-col>
        <van-col span="1"> </van-col>
        <van-col span="8">
          <div
            class="submit"
            :class="money ? 'submit_ok' : 'submit_un_ok'"
            @click.stop="handleSubmit"
            v-show="!is_submit"
          >
            提交订单
          </div>

          <div class="submit submit_un_ok" v-show="is_submit">提交订单</div>
        </van-col>
      </van-row>
    </div>
    <van-dialog v-model="show" title="" @confirm="handleconfirm" @cancel="show=false" confirmButtonText="去充值" confirmButtonColor="#F9591B" cancelButtonColor="#999999" show-cancel-button>
        <span class="tips">您当前卡包余额为<span style="color:#F9591B;">{{parseFloat(balance)+parseFloat(amount)}}</span>元，余额不足，暂无法抵扣。请前往充值</span>
    </van-dialog>
    <div class="order-loading" v-if="loading1">
      <img src="../../assets/shared-hotel/loading.gif" />
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import dsbridge from "dsbridge";
export default {
data() {
    return {
      shop_id: "",
      money: null,
      balance:null,//卡包余额
      amount:null,//赠送金额
      show:false,//卡包余额不足的提醒
      now_coin: "",
      deduction: null,
      equipment: null,
      loading1: false,
      is_submit: false,
      defaultPhoneHeight: "",
      nowPhoneHeight: "",
      isshowbottom: true,
      actual_amount:0,
    };
  },
  watch: {
    //处理键盘弹起时底部内容不跟随
    nowPhoneHeight: function () {
      if (this.defaultPhoneHeight != this.nowPhoneHeight) {
        //手机键盘被唤起了。
        this.isshowbottom = false;
      } else {
        //手机键盘被关闭了。
        this.isshowbottom = true;
      }
    },
  },
  created() {
    //处理键盘弹起时底部内容不跟随
    this.defaultPhoneHeight = window.innerHeight;
    window.addEventListener(
      "resize",
      () => (this.nowPhoneHeight = window.innerHeight)
    );
    this.shop_id = this.$route.query.id;
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    //获取卡包余额和赠送金额
    this.$api.get("/offshop/member/canteen/membership-card/balance-and-award", {shop_id:this.shop_id}).then((res) => {
        if(res.status==0){
            Toast("卡包账户已被禁用，暂不可使用");
            this.$router.go(-1);
            return false;
        }else{
            this.balance=res.balance_amount;
            this.amount = res.award_amount;  
        }
    });
    this.deductionUA();
  },
  mounted() {
    window.setPay = this.setPay;
  },
  computed: {},
  methods: {
    handleInput(e) {
      if (!this.money) {
        this._money = "";
        return;
      }
      if (/^0[^\.]+/.test(this.money)) {
        this.money = this.money.replace(/^0/, "");
      }
      let reg = /^(\d{1,7}(\.\d{0,2}|\d{0,2}|(\d\.\d?))?)$/;
      if (reg.test(this.money)) {
        this._money = this.money = this.money.replace(reg, "$1");
      } else {
        this.money = this._money || "";
      }
    //   if (this.radio.length > 0) {
    //     this.handleChange();
    //   }
    },

    //卡包余额不足去充值
    handleconfirm() {
        this.$router.push({
        path: "/sharedHotel/store",
        query: {
              long: localStorage.getItem('longitude'),
              lat:localStorage.getItem('latitude'),
            },
      });
    },
    handleMore() {
      return Toast("请勿多次点击！");
    },
    handleSubmit() {
      if (!this.money) {
        return Toast("请填写金额");
      }
      if(parseFloat(this.money)>parseFloat(this.balance)+parseFloat(this.amount)){
          this.show=true;
          return false;
      }
      this.is_submit = true;
      this.loading1=true;
      let params={
          "shop_id": this.shop_id,//店铺id
        "order_amount": this.money,//金额
        "is_use_deduct_credit2": 0,//是否用微币抵扣 0：否  1：是
        "scan_type": 3,//扫码类型：3是生活app扫码  4是支付宝扫码  5是微信扫码
        "is_submit": 1,
        "is_canteen":1,//用于判断是否共享饭店订单
        "order": { type: 'canteen_card_order' },//{type:'scan_order'}
      }
      this.$api.post('/order/member/order/confirm',params).then((res)=>{
          let pre = res.order.confirm[0];
          let paramss={
              "shop_id": this.shop_id,
            "order": {
              type: "canteen_card_order",//{type:'scan_order'}
              client: this.equipment,
              confirm: res.order.confirm,
            },
            "order_amount": pre && pre.order_amount,
            "is_use_deduct_credit2": 0,
            "scan_type": 3,
          }
        this.$api.post('/order/member/order/create',paramss).then((ress)=>{
            this.loading1=false;
            this.is_submit=false;
            this.actual_amount=ress.actual_amount
              const param = {
                actual_amount: ress.actual_amount, //实际金额
                order_amount: ress.order_amount, //订单金额
                given_amount:this.amount,//赠送金额
                shop_id:this.shop_id,//店铺id
                ordersn: ress.ordersn, //订单号
                order_type: "card_pay",
              };
              if (this.equipment === 11) {
                let that = this;
                dsbridge.call("goPay", JSON.stringify(param), function (v) {
                  that.setPay(v);
                });
              } else if (this.equipment === 10) {
                this.params(
                  JSON.stringify(param),
                  JSON.stringify(param),
                  "goPay"
                );
              }
        }).catch((err) => {
            this.loading1=false;
            this.is_submit=false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          Toast(message);
        });
      }).catch((err) => {
          this.loading1=false;
          this.is_submit=false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          Toast(message);
        });
    },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.equipment = 11;
      } else if (/android/.test(ua)) {
        this.equipment = 10;
      }
    },
    setPay(v) {
      let data = JSON.parse(v);
      if (data.code == 0) {
        this.$router.push({
          //支付成功
          path: "/sharedHotel/paymentResult",
          query:{
              actual_amount:this.actual_amount,
              type:1,
              shop_id:this.shop_id
          }
        });
      } else {
        this.$router.go(-1);
      }
    },
    reBack() {
      this.$router.go(-1);
    },
  },
}
</script>

<style lang="less" scoped>
.immediatelyPay {
  background-color: #f5f5f5;
  // height: 100%;
}
.tips{
    display: block;
    text-align: center;
    margin: 20px auto;
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}
.header {
  // height: 48px;
  background-color: #fff;
  text-align: center;
  padding-top: 44px;
  box-sizing: border-box;
  position: fixed;
  display: revert;
  top: 0;
  width: 100%;
  z-index: 999;
}
.headerDiv {
  width: calc(100% - 40px);
  margin: 0 auto;
  display: flex;
  .title {
    line-height: 48px;
    font-size: 18px;
    color: #333;
    font-weight: 600;
    width: calc(100% - 38px);
  }
}
.call_back {
  img {
    width: 18px;
    height: 18px;
    margin-top: 16px;
  }
}

.content {
  padding-bottom: 86px;
  padding-top: 100px;
  // height: calc(100% - 44px);
  // overflow: hidden;
  // /* overflow-y: hidden; 解决上拉刷新容器会在开始时自身可以滚动 */
  .pay_shop_body {
    width: calc(100% - 24px);
    margin: 0 auto;
  }
  .pay_shop_div {
    background: #fff;
    border-radius: 10px;
    .pay_shop {
      padding: 15px 0 15px 18px;
      border-bottom: 1px solid #f5f5f5;
    }
    .pay_shop_img {
      width: 28px;
      height: 28px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 20px;
      }
    }
    .pay_shop_name {
      font-size: 16px;
      color: #333;
      font-weight: 600;
      margin-left: 7px;
      margin-top: 2px;
    }
  }

  .consumption {
    color: #333;
    font-size: 16px;
    margin: 15px;
  }
  .sum_of_consumption {
    // padding-bottom: 15px;
    span {
      font-size: 20px;
      margin-left: 15px;
    }
    input {
      margin-left: 9px;
      color: #333;
      font-size: 20px;
      border: none;
      outline: none;
      font-weight: 600;
    }
  }
  .hint {
    font-size: 12px;
    color: #666;
    line-height: 22px;
    margin: 14px 0 70px;
  }
}
.total_body {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;

  .total_title_body {
    width: calc(100% - 24px);
    margin: 0 auto 10px;
    // height: 50px;
    padding-bottom: 34px;

    .total_div {
      text-align: right;
      margin-top: 15px;
      font-size: 13px;
      color: #333;
      // .total_title {
      .total_symbol {
        font-size: 13px;
      }
      .total_money {
        font-size: 22px;
        font-weight: 600;
      }
      .total_money_decimals {
        font-size: 16px;
        font-weight: 600;
      }
      // }
    }
    .submit {
      padding: 6px 15px;
      color: #fff;
      font-weight: 600;
      font-size: 18px;
      margin-top: 7px;
      border: none;
      text-align: center;
      border-radius: 30px;
    }
    .submit_ok {
      background-image: linear-gradient(to right, #fc740c, #f41a3c);
    }
    .submit_un_ok {
      background-image: linear-gradient(to right, #c8c9cc, #c8c9cc);
    }
  }
}
.order-loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }
</style>
<style lang="less">
.van-dialog{
    border-radius: 3px;
    width: 274px;
}
.van-checkbox--horizontal {
  position: absolute;
  right: 0;
  margin-right: 0;
}
.van-icon-success {
  border-radius: 20px;
}
.van-checkbox__icon--checked .van-icon {
  // border-radius: 20px;
  // background: #f9591b;
  border: none;
}
.van-checkbox__icon--checked .van-icon-success::before {
  content: "";
  display: inline-block;
//   background: url("../../../assets/order/unSelect.png");
  background-size: 100% 100%;
  width: 15px;
  height: 15px;
  background-repeat: no-repeat;
}
.van-icon-success::before {
  content: "";
  display: inline-block;
//   background-image: url("../../../assets/order/unSucess.png");
  background-size: 100% 100%;
  width: 15px;
  height: 15px;
  background-repeat: no-repeat;
}
.van-icon-success::before {
  background-color: rgba(255, 255, 255, 0) !important;
  border: none;
}
.van-checkbox__icon--checked .van-icon {
  background-color: rgba(255, 255, 255, 0) !important;
  border: none;
}
.van-checkbox__icon--disabled .van-icon {
  background-color: rgba(255, 255, 255, 0) !important;
  border: none;
}
.van-checkbox__icon .van-icon {
  background-color: rgba(255, 255, 255, 0) !important;
  border: none;
}
.sum_of_consumption .money_input {
  &::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #ccc;
  }

  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #ccc;
  }

  &::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #ccc;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #ccc;
  }
}
</style>
